// extracted by mini-css-extract-plugin
export default {"subNav":"index_subNav_VSeLS"};